import React, { Component } from "react";
import style from "./style.module.css";
import HoverOverlay from "views/components/Editor/elements/HoverOverlay/HoverOverlay";
import { jsonStringEqual } from "lib/equalityUtils";
import Table2Row from "./Table2Row/Table2Row";
import { identity } from "lib";
import {
  getCombinedAnimatedStyles,
  shouldAnimateElement
} from "lib/animationUtils";
import { Flipper } from "react-flip-toolkit";
class Table2 extends Component {
  static defaultProps = {
    connectDragSource: identity
  };

  constructor(props) {
    super(props);
    this.getTableStyle = this.getTableStyle.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.tableRef = React.createRef();

    this.state = {
      lockedCellIds: this.props.elementData.lockedCellIds,
      isHovered: false
    };
  }

  shouldComponentUpdate(nextProps, prevState) {
    if (!jsonStringEqual(this.props.layout, nextProps.layout)) {
      return true;
    } else if (!jsonStringEqual(this.props.cells, nextProps.cells)) {
      return true;
    } else if (
      !jsonStringEqual(this.props.elementData, nextProps.elementData)
    ) {
      return true;
    } else if (this.state.isHovered !== prevState.isHovered) {
      return true;
    } else if (nextProps.isPlaying !== this.props.isPlaying) {
      return true;
    } else if (nextProps.isPaused !== this.props.isPaused) {
      return true;
    } else if (nextProps.currentPlayingTime !== this.props.currentPlayingTime) {
      return true;
    }
    return false;
  }

  getTableStyle() {
    const { width, height, opacity } = this.props.elementData;

    return {
      ...this.props.style,
      opacity,
      // allow table to grow in height when editing
      height: this.props.isEditingCells ? "100%" : height,
      width
    };
  }

  onSelect(e) {
    e.stopPropagation();
    e.preventDefault();

    /* if user pressed shift or meta/command(mac), we append the to the delection*/
    const append = e.shiftKey || e.metaKey;

    const selectedCell = e.target.closest("td");
    let selectedCellId;
    if (selectedCell) selectedCellId = selectedCell.id.split("table-cell-")[1];

    this.props.onSelectItem({ append, selectedCellId });
  }

  onMouseEnter() {
    this.setState({ isHovered: true });
  }

  onMouseLeave() {
    this.setState({ isHovered: false });
  }

  showHoverOverlay() {
    const { isOnlyElementSelected, isSelected, isAllRestrictionsLocked } =
      this.props;
    const { isHovered } = this.state;

    if (isOnlyElementSelected || isSelected || isAllRestrictionsLocked) {
      return false;
    }

    return isHovered;
  }

  render() {
    const tableStyle = this.getTableStyle();
    const flipKey = `table-${this.props.elementData.uniqueId}-${JSON.stringify(
      this.props.elementData.layout.map(row => row.map(cell => cell.id))
    )}`;

    const Table2 = (
      <div
        className={style.tableWrapper}
        style={tableStyle}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.onSelect}
        data-testid="Table2Element"
        id={`${this.props.isPreview ? "preview" : "table2-element"}-${
          this.props.elementData.uniqueId
        }`}
        draggable={true}
        ref={this.tableRef}
      >
        <Flipper
          flipKey={flipKey}
          spring={{
            stiffness: 150,
            damping: 20
          }}
        >
          <table>
            <colgroup>
              {this.props.elementData.layout[0].map((col, index) => (
                <col
                  id={`colgroup-${this.props.elementData.uniqueId}-${index}`}
                  key={index}
                />
              ))}
            </colgroup>
            <tbody>
              {this.props.elementData.layout.map((row, rowIndex) => (
                <Table2Row
                  key={rowIndex}
                  isPreview={this.props.isPreview}
                  row={row}
                  rowIndex={rowIndex}
                  elementData={this.props.elementData}
                  zoom={this.props.zoom}
                  lockedRowResizeCellIds={this.props.lockedRowResizeCellIds}
                  lockedColumnResizeCellIds={
                    this.props.lockedColumnResizeCellIds
                  }
                />
              ))}
            </tbody>
          </table>
        </Flipper>
        {this.showHoverOverlay() && (
          <HoverOverlay
            height={this.props.elementData.height}
            width={this.props.elementData.width}
            zoom={this.props.zoom}
          />
        )}
      </div>
    );

    const shouldAnimate = shouldAnimateElement(
      this.props.elementData,
      this.props.isPlaying,
      this.props.isPaused || false
    );
    if (shouldAnimate) {
      const animationWrapperStyle = getCombinedAnimatedStyles(
        { position: "relative" },
        this.props.elementData,
        this.props.isPlaying,
        this.props.pageId,
        this.props.zoom,
        this.props.currentPlayingTime || 0,
        this.props.isPaused || false
      );

      return this.props.connectDragSource(
        <div style={animationWrapperStyle}>{Table2}</div>
      );
    }

    return this.props.connectDragSource(Table2);
  }
}

export default Table2;
